export default {
  filesCache: []
};
